export const REVENUECAT_BILLING_PUBLIC_API_KEY = process.env.REACT_APP_REVENUECAT_PUBLIC_KEY || '';
export const BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const UrlConstant = {
  Push: {
    RegisterDevice: `${BASE_URL}/api/v1/user/devices/register`,
    UnlinkDevice: `${BASE_URL}/api/v1/user/devices/unlink`,
    Notifications: `${BASE_URL}/api/v1/user/notifications`,
    NotificationsUnreadCount: `${BASE_URL}/api/v1/user/notifications/unread-count`,
    NotificationsMarkRead: `${BASE_URL}/api/v1/user/notifications/read`,
  },
  Common: {
    CountryList: `${BASE_URL}/api/v1/countryDetails`,
    StateList: `${BASE_URL}/api/v1/trading-block/get-states`,
    Countries: `${BASE_URL}/api/v1/countries`,
    CountryStates: (countryCode: string) =>
      `${BASE_URL}/api/v1/countries/${encodeURIComponent(countryCode)}/states`,
  },

  Auth: {
    AcceptEConsent: `${BASE_URL}/api/v1/user/accept-econsent`,
    SignUp: `${BASE_URL}/api/v1/signup`,
    VerifyEmailByOTP: `${BASE_URL}/api/v1/user/verifyEmail`,
    ResendOTP: `${BASE_URL}/api/v1/user/resendOTPVerifyEmail`,
    Login: `${BASE_URL}/api/v1/login`,
    ForgotPassword: `${BASE_URL}/api/v1/forgotPassword`,
    ResetPassword: `${BASE_URL}/api/v1/resetPassword`,
    AcceptDisclosure: `${BASE_URL}/api/v1/user/acceptProductDisclosure`,
    CreatePin: `${BASE_URL}/api/v1/user/createPin`,
    LoginWithPin: `${BASE_URL}/api/v1/user/loginWithPin`,
    UploadProfilePic: `${BASE_URL}/api/v1/user/updateUserProfilePic`,
    updateUser: `${BASE_URL}/api/v1/user/update-user`,
    sendPhoneOTP: `${BASE_URL}/api/v1/otp/send`,
    verifyPhoneOTP: `${BASE_URL}/api/v1/otp/verify`,
    ResendPhoneOTP: `${BASE_URL}/api/v1/otp/resend`,
  },
  TradingAccount: {
    GetSecurityQuestion: `${BASE_URL}/api/v1/trading-block/getSecurityQuestions`,
    CreateUser: `${BASE_URL}/api/v1/trading-block/create-user`,
    CheckAccountStatus: `${BASE_URL}/api/v1/trading-block/get-account-status`,
    CheckAccountStatusV2: `${BASE_URL}/api/v2/trading-block/get-account-status`,
    CreateAccount: `${BASE_URL}/api/v1/trading-block/create-account`,
    GetSectionAnswer: `${BASE_URL}/api/v1/trading-block/get-answers`,
    SubmitAnswer: `${BASE_URL}/api/v1/trading-block/submit-answer`,
    SubmitForm: `${BASE_URL}/api/v1/trading-block/submit-form`,
    GetInvestigation: `${BASE_URL}/api/v1/trading-block/get-investigation`,
    SubmitDocument: `${BASE_URL}/api/v1/trading-block/submit-document`,
  },
  Sumsub: {
    CreateAccount: `${BASE_URL}/api/v1/application/form`,
    GetSectionAnswer: `${BASE_URL}/api/v1/application/form/answers`,
    SubmitAnswer: `${BASE_URL}/api/v1/application/submit-answers`,
    SubmitForm: `${BASE_URL}/api/v1/application/submit`,
    CheckAccountStatus: `${BASE_URL}/api/v1/kyc/status`,
    GetUploadedImages: `${BASE_URL}/api/v1/application/kyc/uploaded-images`,
  },
  WachList: {
    GetWatchList: `${BASE_URL}/api/v1/watchlist/list`,
    CreateWatchList: `${BASE_URL}/api/v1/watchlist/create`,
    RemoveWatchList: `${BASE_URL}/api/v1/watchlist/remove/{0}`,
  },
  AiPicks: {
    GetAiPicks: `${BASE_URL}/api/v1/top-picks`,
    GetAiPicksOfFollowing: `${BASE_URL}/api/v1/user/topPicksOfFollowing?type={0}`,
  },
  MyPicks: {
    GetMyPicksLive: `${BASE_URL}/api/v1/recommendation/list?type={0}`,
    GetMyPicksHistory: `${BASE_URL}/api/v1/recommendation/history?type={0}`,
  },
  TopStocks: {
    GetTopStocksByMarketCap: `${BASE_URL}/api/v1/top-stocks-by-market-cap`,
  },
  Stock: {
    GetStockDetail: `/api/v1/stockdata/{0}`,
    GetTiker: `/api/v1/trading-block/delayed-ticker?ticker={0}`,
    GetTickerHistory: `/api/v1/premium/tickerHistorical?symbol={0}`,
    GetStockFinancialDetail: `/api/v1/stockdata/get-stock-financials?ticker={0}`
  },
  Discovery: {
    preferences: `${BASE_URL}/api/v1/preference`,
    updateActivation: `${BASE_URL}/api/v1/preference/updateActivation`,
    createPreference: `${BASE_URL}/api/v1/preference/createPreference`,
    getPreferenceDetails: `${BASE_URL}/api/v1/preference/getPreferenceDetails?preferenceId={0}`,
    getPreferenceFields: `${BASE_URL}/api/v1/field/getFieldList?type={0}`,
    updatePreferenceData: `${BASE_URL}/api/v1/preference/updatePreferenceData`,
    deletePreferenceData: `${BASE_URL}/api/v1/preference/deletePreference`,
  },
  MarketMovers: {
    GetMarketMovers: `${BASE_URL}/api/v1//trading-block/market-movers?type={0}`,
  },
  BuySell: {
    AvailbleQty: `${BASE_URL}/api/v1/trading-block/getQuantity/{symbol}`,
    GetTradingBalance: `${BASE_URL}/api/v1/trading-block/check-trading-balance`,
    PlaceBuyOrderFake: `${BASE_URL}/api/v1/trading-block/place-order-fake`,
    PlaceBuyOrder: `${BASE_URL}/api/v1/trading-block/place-order`,
  },
  BoosterLoan: {
    CheckBoosterEligibility: `${BASE_URL}/api/v1/booster-loan/check-loan-eligibility`,
    CheckBoosterLoan: `${BASE_URL}/api/v1/booster-loan/check-loan-for-stock?symbol={0}`,
    GetLoanAmount: `${BASE_URL}/api/v1/booster-loan/get-loan-amount?amount={0}&offerId={1}`,
    GetPaymentMethod: `${BASE_URL}/api/v1/booster-loan/get-loan-payment-method`,
    UpdatePaymentMethod: `${BASE_URL}/api/v1/booster-loan/update-loan-payment-method`,
    GetLoanDetails: `${BASE_URL}/api/v1/booster-loan/loan-draft?symbol={0}&price={1}`,
    GetBoosterSummary: `${BASE_URL}/api/v1/booster-loan/loan-home`,
    GetBoosterLoanRepayment: `${BASE_URL}/api/v1/booster-loan/loan-repayment`,
    GetBoosterLoanActive: `${BASE_URL}/api/v1/booster-loan/user-loan?isActive={0}`,
    GetBoosterLoanInstallment: `${BASE_URL}/api/v1/booster-loan/loan-installment?loanId={0}`,
    BoosterLending: `${BASE_URL}/api/v1/booster-loan/registerIntrestForBooster`,
    CreateUser: `${BASE_URL}/api/v1/booster-loan/create-user`,
    GetCryptoMarketList: `${BASE_URL}/api/v1/booster-loan/crypto?pageNumber={pageNumber}&pageSize={pageSize}&shortColumn={shortColumn}&shortType={shortType}`,
    GetCryptoMarketDetail: `${BASE_URL}/api/v1/booster-loan/crypto?externalId={externalId}`,
    BOOSTER_LOAN_ADD_PAYMENT_PROFILE: `${BASE_URL}/api/v1/booster-loan/add-payment-profile`,
    BOOSTER_LOAN_EDIT_PAYMENT_PROFILE: `${BASE_URL}/api/v1/booster-loan/edit-payment-profile`,
    BOOSTER_LOAN_DELETE_PAYMENT_PROFILE: `${BASE_URL}/api/v1/booster-loan/delete-payment-profile`,
    BOOSTER_LOAN_MANUAL_PAY_LOAN: `${BASE_URL}/api/v1/booster-loan/manual-pay-loan`,
    GetPromissoryHtml: `${BASE_URL}/api/v1/user/promissory/html`,
    AcceptPromissory: `${BASE_URL}/api/v1/user/promissory/accept`,
    ConfirmationHtml: `${BASE_URL}/api/v1/booster-loan/confirmation/html`,
  },
  Market: {
    GetMarketSignalsFilters: `${BASE_URL}/api/v1/premium/get-filters`,
    GetMarketSignalsFiltersData: `${BASE_URL}/api/v1/premium/get-filter-data`,
    GetMArketSignalCategories: `${BASE_URL}/api/v1/premium/get-categories`,
    GetMarketSignalByCategory: `${BASE_URL}/api/v1/premium/get-by-signal-category?signalName={0}&category={1}`,
  },
  Portfolio: {
    GetPortfolio: `${BASE_URL}/api/v1/trading-block/portfolio`,
    TransactionHistory: `${BASE_URL}/api/v1/trading-block/order-transaction-history`,
  },
  Stepper3: {
    getPreferenceDetails: `${BASE_URL}/api/v1/preference/getPreferenceDetails?preferenceId=6052ea74669996bc33e6acb8`,
  },
  AutoTopup: {
    CreateAutoTopupPopup: `${BASE_URL}/api/v1/top-ups/create`,
    UpcomingAutotopup: `${BASE_URL}/api/v1/top-ups/upcomming?offset=0&limit=20`,
    HistoryTopup: `${BASE_URL}/api/v1/top-ups/history?offset=0&limit=20`,
    getUpcomingTopupDetails: `${BASE_URL}/api/v1/top-ups/upcomming/{0}?offset=0&limit=20`,
    getHistoryTopupDetails: `${BASE_URL}/api/v1/top-ups/history/{0}?offset=0&limit=20`,
    deletestock: `${BASE_URL}/api/v1/top-ups/delete`
  },
  Order: {
    orderList: `${BASE_URL}/api/v1/trading-block/order-list`,
    cancelOrderList: `${BASE_URL}/api/v1/trading-block/order-cancel`
  },
  StockIcon: {
    baseUrl: process.env.REACT_APP_STOCK_LOGO_BASE_URL,
    fileType: '.png',
    apiKey: process.env.REACT_APP_STOCK_LOGO_API_KEY
  },
  Transfer: {
    GetTransferList: `${BASE_URL}/api/v1/trading-block/transaction-list?direction={dir}&offset=0&limit=30`,
    TransactionHistory: `${BASE_URL}/api/v1/trading-block/order-transaction-history`,
    GetBankAccounts: `${BASE_URL}/api/v1/trading-block/list-link-accounts`,
    DepositeAmount: `${BASE_URL}/api/v1/trading-block/deposit`,
    WithdrawAmount: `${BASE_URL}/api/v1/trading-block/withdrawal`,
    CancelTransfer: `${BASE_URL}/api/v1/trading-block/cancel-transfer`,
    CheckBalance: `${BASE_URL}/api/v1/trading-block/check-account-balance`,
    GetACHFee: `${BASE_URL}/api/v1/admin/get-deposit-fees`,
  },
  Address: {
    getState: `${BASE_URL}/api/v1/trading-block/get-states`,
    getAddressDetails: `${BASE_URL}/api/v1/trading-block/get-account-details`,
    updateAddress: `${BASE_URL}/api/v1/trading-block/update-account-details`
  },
  Documents: {
    Statement: `${BASE_URL}/api/v1/trading-block/monthly-statement`,
    Confirm: `${BASE_URL}/api/v1/trading-block/daily-confirm`,
    TaxForms: `${BASE_URL}/api/v1/trading-block/tax-documents`,
    DownloadStatement: `${BASE_URL}/api/v1/trading-block/monthly-statement-pdf`,
    DownloadDailyConfirm: `${BASE_URL}/api/v1/trading-block/daily-confirm-pdf`,
    DownloadTaxForm: `${BASE_URL}/api/v1/trading-block/tax-documents-pdf`,
    TradeConfirmations: '/api/v1/documents/trade-confirmations',
    TradeConfirmationsPDF: '/api/v1/documents/trade-confirmations-pdf',
    TradeConfirmationsBulkPDF: '/api/v1/documents/trade-confirmations-bulk-pdf'
  },
  Settings: {
    usersettings: `${BASE_URL}/api/v1/usersettings`,
    setUserSetting: `${BASE_URL}/api/v1/usersettings/setUserSettings`,
    changePin: `${BASE_URL}/api/v1/user/createPin`,
    deleteAccount: `${BASE_URL}/api/v1/user/delete-account`
  },
  BankAccount: {
    LinkedList: `${BASE_URL}/api/v1/trading-block/list-link-accounts`,
    CreateLinkToken: `${BASE_URL}/api/v1/trading-block/create-link-token?accountId={0}`,
    CompleteLink: `${BASE_URL}/api/v1/trading-block/complete-link`,
    UnlinkAccount: `${BASE_URL}/api/v1/trading-block/unlink-account`,
    SetDefaultAccount: `${BASE_URL}/api/v1/trading-block/set-default-account/{0}`,
  },
  ReferFriend: {
    ReferralData: `${BASE_URL}/api/v1/user/getReferralData`,
    getSpinData: `${BASE_URL}/api/v1/user/getSpinData`,
    getSpinDataV2: `${BASE_URL}/api/v1/user/getSpinDataV2`,
    redeemSpin: `${BASE_URL}/api/v1/user/redeemSpin`,
    UpdateSpinAmount: `${BASE_URL}/api/v1/user/updateSpinAmount`,
    createDiscountVoucher: `${BASE_URL}/api/v1/user/create-discount-voucher`,
    createReferralDepositRequest: `${BASE_URL}/api/v1/user/referral-deposit-request`,
    getReferralDepositHistory: `${BASE_URL}/api/v1/user/referral-deposit-history`
  },
  Profile: {
    getProfile: `${BASE_URL}/api/v1/user/profile/{0}`,
    getTopPickStock: `${BASE_URL}/api/v1/user/userTopPicks/{0}?type=STOCK`,
    getTopPickETF: `${BASE_URL}/api/v1/user/userTopPicks/{0}?type=ETF `,
    searchUser: `${BASE_URL}/api/v1/user/search?search={0}&offset=0&limit=20`,
    userFollow: `${BASE_URL}/api/v1/follow/{0}`,
    userUnfollow: `${BASE_URL}/api/v1/unfollow/{0}`,
    userFollowerList: `${BASE_URL}/api/v1/user/followerList/{0}`,
    userBlock: `${BASE_URL}/api/v1/user/block/{0}`,
    userUnBlock: `${BASE_URL}/api/v1/user/unblock/{0}`,
    userFollowingList: `${BASE_URL}/api/v1/user/followingList/{0}`,
    userAssetData: `${BASE_URL}/api/v1/user/{0}/get-user-profile-data`,
    userBlockedList: `${BASE_URL}/api/v1/user/blocked-users`
  },
  Header: {
    searchStock: `${BASE_URL}/api/v2/stockdata/list?stock_name={0}&offset=0&limit=20`
  },
  TradeIdea: {
    getTradeIdea: `${BASE_URL}/api/v1/premium/tradeIdeas`
  },
  MarketTrackers: {
    getMarketTrackers: `${BASE_URL}/api/v1/premium/marketTrackers`
  },
  Insights: {
    getInsightData: `${BASE_URL}/api/v1/premium/insightData?symbol={0}`
  },
  AskMrWolf: {
    askMrWolf: `${BASE_URL}/api/v1/trading-block/askMrWolf`
  },
  InvestmentChart: {
    getInvestmentChart: `${BASE_URL}/api/v1/trading-block/investment-chart?period={0}`
  },
  AiAnalysis: {
    getAiAnalysis: `${BASE_URL}/api/v1/trading-block/aiAnalysis?symbol={0}&assetType={1}`
  },
  Crypto: {
    CreateAccount: `${BASE_URL}/api/v1/sfox/complete-link`,
    GetAccounts: `${BASE_URL}/api/v1/sfox/get-account`,
    CreateLinkToken: `${BASE_URL}/api/v1/sfox/create-link-token`,
    SetDefaultAccount: `${BASE_URL}/api/v1/sfox/set-default-account/{0}`,
    UnlinkAccount: `${BASE_URL}/api/v1/sfox/delete-account`,
    DepositeAmount: `${BASE_URL}/api/v1/sfox/bank-deposit`,
    WithdrawAmount: `${BASE_URL}/api/v1/sfox/bank-withdraw`,
    CancelTransaction: `${BASE_URL}/api/v1/sfox/transaction/{0}`,
    TransactionHistory: `${BASE_URL}/api/v1/sfox/order-history`,
    CheckBalance: `${BASE_URL}/api/v1/sfox/user-balance`,
    CyproGetFormData: `${BASE_URL}/api/v1/crypto/get-form-data`,
    SendVerification: `${BASE_URL}/api/v1/crypto/send-verification`,
    CryptoSectionAnswer: `${BASE_URL}/api/v1/crypto/get-answers`,
    CryptoSubmitAnwer: `${BASE_URL}/api/v1/crypto/submit-answer`,
    CryptoAccountStatus: `${BASE_URL}/api/v1/crypto/account-status`,
    getSumSubAccessToken: `${BASE_URL}/api/v1/kyc/generate-token`,
    BinanceKlines: 'https://api.binance.com/api/v3/klines?symbol={symbol}&interval={interval}&limit={limit}',
    Candlesticks: `${BASE_URL}/api/v1/crypto/candlesticks`,
    GetCryptoList: `${BASE_URL}/api/v1/crypto/list`,
    GetCryptoMarketDetail: `${BASE_URL}/api/v1/crypto/list?externalId={externalId}`,
    PlaceBuyOrder: `${BASE_URL}/api/v1/trades/buy`,
    PlaceSellOrder: `${BASE_URL}/api/v1/trades/sell`,
    VerifyTransfer: `${BASE_URL}/api/v1/crypto/confirm-transfer`,
    ResendConfirmation: `${BASE_URL}/api/v1/crypto/resend-confirmation`,
    GetCryptoOrders: `${BASE_URL}/api/v1/crypto/orders`,
    CancelOrder: `${BASE_URL}/api/v1/crypto/orders/cancel`,
    Portfolio: `${BASE_URL}/api/v1/crypto/portfolio`,
    GetCryptoInvestmentChart: `${BASE_URL}/api/v1/crypto/investments`,
    GetCryptoLoan: `${BASE_URL}/api/v1/crypto/get-crypto-loan`,
    GetCryptoLoanByStock: `${BASE_URL}/api/v1/crypto/get-loan-by-stock`,
    GetCryptoSearch: `${BASE_URL}/api/v1/crypto/list?search={0}`,
    GetCryptoPrepaymentAmount: `${BASE_URL}/api/v1/crypto/get-prepayment-loan-amount`,
    PrePayCryptoLoan: `${BASE_URL}/api/v1/crypto/loan-pre-pay`,
    CreateManualBankAccount: `${BASE_URL}/api/v1/sfox/create-bank-account`,
    GetTradeIdeas: `${BASE_URL}/api/v1/crypto/trade-ideas`,
    GetInternationalWireInstructions: `${BASE_URL}/api/v1/crypto/international-wire-instructions`,
    OnboardACH: `${BASE_URL}/api/v1/sfox/onboard-ach`,
    VerifyACH: `${BASE_URL}/api/v1/sfox/verify-ach`
  },
  Cashout: {
    GetCashoutAssets: `${BASE_URL}/api/v1/cashout/available-assets`,
    SubmitCashoutRequest: `${BASE_URL}/api/v1/cashout/submit`,
  },
  AeroPay: {
    Createuser: `${BASE_URL}/api/v1/aeropay/create-aeropay-user`,
    LinkBank: `${BASE_URL}/api/v1/aeropay/link-bank-account`,
    VerifyOtp: `${BASE_URL}/api/v1/aeropay/verify-aeropay-user`,
    Linkbankaccountaggregator: `${BASE_URL}/api/v1/aeropay/link-bank-account-aggregator`,
    Getbankdetails: `${BASE_URL}/api/v1/aeropay/get-user-bank-details`,
    depositAmount: `${BASE_URL}/api/v1/aeropay/aeropay-deposit`,
    transferHistory: `${BASE_URL}/api/v1/aeropay/get-transfer-history`,
    userBalance: `${BASE_URL}/api/v1/aeropay/get-user-balance`,
    withdrawAmount: `${BASE_URL}/api/v1/aeropay/aeropay-withdraw`,
    changeDefaultBank: `${BASE_URL}/api/v1/aeropay/select-default-bank-account`,
    GetWireInstructions: `${BASE_URL}/api/v1/aeropay/get-wire-bank-details`,
  },
  User: {
    GetUserBalance: `${BASE_URL}/api/v1/user/balance`,
    Portfolio: `${BASE_URL}/api/v1/user/portfolio`,
    CreateUserWithdrawRequest: `${BASE_URL}/api/v1/user/user-withdrawal`,
    CancelWithdrawRequest: `${BASE_URL}/api/v1/user/process-withdrawal-cancel-by-user`,
    GetMonthlyStatement: `${BASE_URL}/api/v1/user/get-monthly-statement`,
    GetDocumentPassword: `${BASE_URL}/api/v1/usersettings/get-document-password`,
    GetAllPaymentMethods: `${BASE_URL}/api/v1/user/get-all-payment-methods`,
    GetUserCurrency: `${BASE_URL}/api/v1/user/currency`,
    updateSpinPopupStatus: `${BASE_URL}/api/v1/user/spin/clear-flag`,
    updateDepositBonusPopupStatus: `${BASE_URL}/api/v1/spin/deposit-bonus/dismiss`
  }
};